(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  const layout = (root) => {
    const track = root.querySelector('[data-hf-moments-track]');
    const viewport = root.querySelector('.hf-moments__viewport');
    const set = track?.querySelector('[data-hf-moments-set]');
    if (!track || !viewport || !set) return;

    track.querySelectorAll('[data-hf-moments-set]').forEach((node, index) => {
      if (index > 0) node.remove();
    });

    const setWidth = set.getBoundingClientRect().width;
    const viewWidth = viewport.getBoundingClientRect().width;
    if (!setWidth || !viewWidth) return;

    const copies = Math.max(2, Math.ceil(viewWidth / setWidth) + 2);
    for (let i = 1; i < copies; i += 1) {
      const clone = set.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('[data-shopify-editor-block]').forEach((node) => {
        node.removeAttribute('data-shopify-editor-block');
      });
      clone.querySelectorAll('a').forEach((link) => link.setAttribute('tabindex', '-1'));
      track.appendChild(clone);
    }

    track.style.setProperty('--hf-moments-shift', `${setWidth}px`);
    track.classList.remove('is-measured');
    track.style.animation = 'none';
    void track.offsetWidth;
    track.style.removeProperty('animation');
    track.classList.add('is-measured');
  };

  const boot = (root) => {
    if (reduced.matches) return;
    layout(root);
  };

  const roots = () => document.querySelectorAll('[data-hf-moments]');

  const start = () => roots().forEach(boot);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  let resizeTimer = 0;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => roots().forEach(boot), 150);
  });

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target?.querySelector?.('[data-hf-moments]') || event.target;
    if (root?.matches?.('[data-hf-moments]')) boot(root);
  });
})();
